import { captureMessage } from '@sentry/nextjs'

import { GetUserViewModel } from '@/types/pam-api'

import { WindowWithWebengage } from './types'

declare const window: WindowWithWebengage

export const identify = (userId: string) => {
    if (!window.webengage) return

    try {
        window.webengage.user.login(userId)
    } catch (error) {
        const stringifiedError = JSON.stringify(error)
        captureMessage(stringifiedError)
    }
}

export const signup = () => {
    if (!window.webengage) return

    try {
        window.webengage.track('signup', { date: new Date() })
    } catch (error) {
        const stringifiedError = JSON.stringify(error)
        captureMessage(stringifiedError)
    }
}

export const logout = () => {
    if (!window.webengage) return

    try {
        window.webengage.user.logout()
    } catch (error) {
        const stringifiedError = JSON.stringify(error)
        captureMessage(stringifiedError)
    }
}

export const setUserAttributes = (userData: GetUserViewModel) => {
    const userDataForWebengage = {
        we_first_name: userData.firstName,
        we_last_name: userData.lastName,
        we_email: userData.emailAddress,
        we_hashed_phone: userData.id,
        we_gender: userData.gender && userData.gender.toLocaleLowerCase(),
        we_birth_date: userData.birthDate,
        last_submitted_order_date: userData.lastSubmittedOrderDate ? new Date(userData.lastSubmittedOrderDate) : null,
        total_submitted_order: userData.totalOrder,
        last_order_category: userData.lastOrderCategory,
        state: userData.lastAddressProvinceName,
        city: userData.lastAddressCityName,
        aov: userData.aov,
        wallet_amount: userData.walletAmount,
        join_date: userData.joinDate ? new Date(userData.joinDate) : null,
        rfm_category: userData.lrfmCategory ? userData?.lrfmCategory : null,
    }

    const filteredUserData = Object.fromEntries(
        Object.entries(userDataForWebengage).filter(([, value]) => value != null)
    )

    if (!window.webengage) return
    for (const [key, value] of Object.entries(filteredUserData)) {
        try {
            window.webengage.user.setAttribute(key, value ?? '')
        } catch (error) {
            const stringifiedError = JSON.stringify(error)
            captureMessage(stringifiedError)
        }
    }
}
